module.exports = __webpack_public_path__ + "img/real-estate-icons.f1287b55.png";